import SectionHead from './SectionHead';
import { roundup } from '@/mocks/meihei';

export default function RoundupSection() {
  return (
    <section id="pandian" className="anchor-target bg-paper py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHead
          eyebrow="同类盘点 · 主榜"
          title="像媚黑大赛一样吃满全场的话题，还有六种"
          desc="按传播形态归类出的六类相似现象样本。每一条都用一句话讲清它长什么样，标题 + 摘要的结构，方便你快速对照。"
        />

        <div className="mt-10 space-y-4">
          {roundup.map((item) => (
            <article
              key={item.rank}
              className="group flex flex-col gap-4 rounded-xl border border-line bg-paper p-5 transition-colors hover:border-ember-200 md:flex-row md:items-center md:gap-6 md:p-6"
            >
              <div className="flex items-center gap-4 md:w-20 md:shrink-0">
                <span className="display text-4xl font-black leading-none text-ember-500/20 transition-colors group-hover:text-ember-500">
                  {item.rank}
                </span>
                <div className="md:hidden">
                  <div className="flex items-center gap-1.5">
                    <i className="ri-fire-fill text-honey-400" aria-hidden="true"></i>
                    <span className="display text-sm font-bold text-ink">{item.heat}</span>
                  </div>
                  <span className="text-[11px] text-clay">热度指数</span>
                </div>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="display text-base font-bold leading-snug text-ink md:text-lg">
                    {item.title}
                  </h3>
                  {item.tags.map((t) => (
                    <span
                      key={t}
                      className="whitespace-nowrap rounded-full bg-honey-50 px-2 py-0.5 text-[11px] font-medium text-honey-500"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <p className="mt-2 text-[13px] leading-relaxed text-clay md:text-sm">{item.summary}</p>
              </div>

              <div className="hidden shrink-0 flex-col items-end md:flex">
                <div className="flex items-center gap-1.5 text-clay">
                  <span className="text-[11px] font-medium">热度</span>
                  <span className="display text-base font-bold text-ink">{item.heat}</span>
                </div>
                <div className="mt-2 h-1.5 w-28 overflow-hidden rounded-full bg-cream">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-honey-300 to-ember-500"
                    style={{ width: `${item.heat}%` }}
                  ></div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-8 flex items-start gap-2 rounded-lg bg-cream p-4 text-[13px] leading-relaxed text-clay">
          <i className="ri-information-line mt-0.5 text-ember-500" aria-hidden="true"></i>
          以上为按传播形态归纳的样本视角，用于横向理解同类话题的共通结构；具体个案请以官方与多方信源为准，本页不构成事实定论。
        </p>
      </div>
    </section>
  );
}